module.exports = __webpack_public_path__ + "static/img/5_2.34e10adb.jpg";